import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomService } from 'app/components/dom/dom.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ExhibitorProfileService } from 'app/components/exhibitor-profile/exhibitor-profile.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { OdsService } from 'app/components/ods/ods.service';
import { SearchService } from 'app/components/search/search.service';
import { MapsService } from 'app/components/maps/maps.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { DetailsService } from 'app/components/details/details.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalImportExhibitorComponent } from 'app/components/modal-import-exhibitor/modal-import-exhibitor.component';
import { ModalSimpleComponent } from 'app/components/modal-simple/modal-simple.component';
import { CONSTANTS } from 'environments/common';


@Component({
  selector: 'app-exhibitor-backoffice-exhibitor-detail',
  templateUrl: './exhibitor-backoffice-exhibitor-detail.component.html',
  styleUrls: ['./exhibitor-backoffice-exhibitor-detail.component.css']
})
export class ExhibitorBackofficeExhibitorDetailComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  catalogueId;
  eventName: string|null = '';
  exhibitorId;

  buttonLink: string = '';

  profile: object = {};

  exhibitorData: object = {
    exhibitor: {},
    exhibitorId: null
  };

  exhibitorStatuses: Array<any> = [];

  firaMaps: Array<any> = [];
  ods: Array<any> = [];
  files: Array<any> = [];
  unifiedCategories: Array<any> = [];
  baseDataLoaded: boolean = false;
  countriesMap: object = {};
  socialNetwork: Array<any> = [];
  images: Array<any> = [];
  projection: any = {};
  products: Array<any> = [];
  categories: Array<any> = [];
  type:string = "EXHIBITOR";
  isFavorite: boolean = false;
  odsClass: string[] = [];
  isOdsActive: boolean;
  currentSlideIndex: number = 0;
  
  catalogueProperties: any = {};
  importData: Array<any> = [];
  sapId: string = '';

  constructor(private domService: DomService, private activatedRoute: ActivatedRoute, private exhibitorProfileService: ExhibitorProfileService,
  public catalogueService: CatalogueService, private exhitorsService: ExhitorsService, private odsService: OdsService, private searchService: SearchService,
  private mapsService: MapsService, public utilsService: UtilsService, public detailsService: DetailsService, private router: Router, protected modalService: NgbModal, private ngbModal: NgbModal) {
    this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('exhibitorId') || null;
    this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.buttonLink = this.eventName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/edit'
  }

  getPublishedProducts(getPublishedProductsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getPublishedProducts(getPublishedProductsIn)
      .subscribe((data: object) => {
        this.getPublishedProductsOk(data);
      },
        error => {
          this.getPublishedProductsError(error);
        });

  }

  getPublishedProductsOk(data) {

    this.loader.count--;
    this.products = data;
    console.log('produ');
    console.log(this.products);

  }

  getPublishedProductsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getCategories(getCategoriesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getCategories(getCategoriesIn)
      .subscribe((data: object) => {
        this.getCategoriesOk(data);
      },
        error => {
          this.getCategoriesError(error);
        });

  }

  getCategoriesOk(data) {

    this.loader.count--;
    this.categories = data;
    this.unifyCategories(data.masterProperties);

  }

  getCategoriesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getProjection(getProjectionIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getProjection(getProjectionIn)
      .subscribe((data: object) => {
        this.getProjectionOk(data);
      },
        error => {
          this.getProjectionError(error);
        });

  }

  getProjectionOk(data) {

    this.loader.count--;
    this.projection = data;
    this.catalogueId = this.catalogueService.getProperty('id');

    let getCatalogueAndExhibitorIn = {
      catalogueId: this.catalogueId,
      exhibitorId: this.exhibitorId
    }

    let getHierarchicalPropertiesIn = {
      catalogueId: this.catalogueId,
      exhibitorId: this.exhibitorId
    }

    let getCountriesInUseIn = {
      catalogueId: this.catalogueId
    }

    this.getCatalogueAndExhibitor(getCatalogueAndExhibitorIn);
    this.getCountriesInUse(getCountriesInUseIn);
    this.getHierarchicalProperties(getHierarchicalPropertiesIn);

  }

  getProjectionError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getImages(getImagesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getImages(getImagesIn)
      .subscribe((data: object) => {
        this.getImagesOk(data);
      },
        error => {
          this.getImagesError(error);
        });

  }

  getImagesOk(data) {

    this.loader.count--;
    if(data._embedded.images.length > 0){
      this.images = data._embedded.images;//Revisar en las otros detalles que solo llega un elemento
    }

  }

  getImagesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getSocialNetwork(getSocialNetworkIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getSocialNetwork(getSocialNetworkIn)
      .subscribe((data: object) => {
        this.getSocialNetworkOk(data);
      },
        error => {
          this.getSocialNetworkError(error);
        });

  }

  getSocialNetworkOk(data) {

    this.loader.count--;
    this.socialNetwork = data;

  }

  getSocialNetworkError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getFiraMaps(getFiraMapsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.mapsService.getFiraMaps(getFiraMapsIn)
      .subscribe((data: object) => {
        this.getFiraMapsOk(data);
      },
        error => {
          this.getFiraMapsError(error);
        });

  }

  getFiraMapsOk(data) {

    this.loader.count--;
    this.firaMaps = data;

  }

  getFiraMapsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }
  
  getOds(getOdsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.odsService.getOds(getOdsIn)
      .subscribe((data: object) => {
        this.getOdsOk(data);
      },
        error => {
          this.getOdsError(error);
        });

  }


  getOdsOk(data) {

    this.loader.count--;
    this.ods = (data as any[]).sort((a, b) => {
      const numA = parseInt(a.name.replace('ODS_', ''), 10);
      const numB = parseInt(b.name.replace('ODS_', ''), 10);
      return numA - numB;
    });

  }

  getOdsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
  
  }

  getOdsActive(getOdsActiveIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.odsService.getOdsActive(getOdsActiveIn)
      .subscribe((data: object) => {
        this.getOdsActiveOk(data);
      },
        error => {
          this.getOdsActiveError(error);
        });

  }

  getOdsActiveOk(data) {

    let getOdsIn = {
      exhibitorId: this.exhibitorId 
    }

    this.loader.count--;
    this.isOdsActive = data;
    
    if(this.isOdsActive){
      this.getOds(getOdsIn);
    }

  }

  getOdsActiveError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }
  
  getCatalogueAndExhibitor(getCatalogueAndExhibitorIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.searchService.getCatalogueAndExhibitor(getCatalogueAndExhibitorIn)
      .subscribe((data: object) => {
        this.getCatalogueAndExhibitorOk(data);
      },
        error => {
          this.getCatalogueAndExhibitorError(error);
        });

  }

  getCatalogueAndExhibitorOk(data) {

    this.loader.count--;
    this.files = data['_embedded']['files'];

  }

  getCatalogueAndExhibitorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
  
  }

  getCountriesInUse(getCountriesInUseIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getCountriesInUse(getCountriesInUseIn)
      .subscribe((data: object) => {
        this.getCountriesInUseOk(data);
      },
        error => {
          this.getCountriesInUseError(error);
        });

  }

  getCountriesInUseOk(data) {

    this.loader.count--;
    this.countriesMap = {};
    data._embedded.countries.forEach(ctry => {
      this.countriesMap[ctry.id] = ctry;
      this.baseDataLoaded = true;
    });

  }

  getCountriesInUseError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.baseDataLoaded = true;

  }

  getHierarchicalProperties(getHierarchicalPropertiesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getHierarchicalProperties(getHierarchicalPropertiesIn)
      .subscribe((data: object) => {
        this.getHierarchicalPropertiesOk(data);
      },
        error => {
          this.getHierarchicalPropertiesError(error);
        });

  }

  getHierarchicalPropertiesOk(data) {

    this.loader.count--;
    this.unifyCategories(data);

  }

  getHierarchicalPropertiesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  private readonly mapImagesByPrefix: string[] = CONSTANTS.FAIRGROUNDS_WITH_MAP_IMAGE;

  getMapImage(): string {
    const fairground = this.utilsService.getFairground(this.projection?.standLocation);
    const prefix = this.mapImagesByPrefix.find(p => p === fairground) || 'GV';
    return `assets/img/map-${prefix}.png`;
  }

  unifyCategories(categories) {
    for (let i = 0; i < categories.length; i++) {
      this.unifiedCategories.push(categories[i]);
      if (categories[i].childHierarchicalProperties) {
        this.unifyCategories(categories[i].childHierarchicalProperties);
      }
    }
  }

  fixUrl(url:string):string {
    if (typeof(url) === 'string') {
        if (!url.match(/http/)) {
            return 'http://'+url;
        }
        return url;
    }
    return url;
  }


  exhibitorHasSocialNetworks(exhibitor: any): boolean {
    if (!!exhibitor.facebookUrl || !!exhibitor.twitterUrl || !!exhibitor.instagramUrl || !!exhibitor.googlePlusUrl || !!exhibitor.linkedInUrl || !!exhibitor.flickrUrl || !!exhibitor.pinterestUrl) {
      return true;
    }
    return false;
  }

  goTo(url) {
    this.router.navigate([url]);
  }

  nextSlide() {
    this.currentSlideIndex = (this.currentSlideIndex + 1) % this.images.length;
  }

  previousSlide() {
    this.currentSlideIndex =
      (this.currentSlideIndex - 1 + this.images.length) % this.images.length;
  }

  setImage(url: string) {
    return url ? url : this.catalogueProperties.defaultExhibitorImage || 'assets/img/no_image_available.png';
  }

  importExhibitor() {
    const modalRef = this.modalService.open(ModalImportExhibitorComponent, {size:'lg'});
    modalRef.componentInstance.exhibitorId = this.exhibitorId;
    modalRef.componentInstance.sapId = this.sapId;
    modalRef.componentInstance.importData = JSON.parse(JSON.stringify(this.importData));

    
    modalRef.result.then((result) => {
      if(result.id){
        this.exhitorsService.editCopyExhibitorAndProducts(Number(this.exhibitorId), result).subscribe(res => {
              const modalRef = this.modalService.open(ModalSimpleComponent);
              modalRef.componentInstance.titleTranslation = 'MODAL_SIMPLE.TITLE_INFORMATION';
              modalRef.componentInstance.modalInformation = 'MODAL_SIMPLE.COPY_MSG';
              modalRef.componentInstance.isHtml = false;
        });
      }
    }, (reason) => {
      //console.log('Modal dismissed with:', reason);
    });
  }

  getExhibitor(getExhibitorIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getExhibitor(getExhibitorIn)
      .subscribe((data: object) => {
        this.getExhibitorOk(data);
      },
        error => {
          this.getExhibitorError(error);
        });

  }

  getExhibitorOk(data) {

    this.loader.count--;
    this.sapId = data.sapId;

    let getImportableExhibitorIn = {
      exhibitorId: this.exhibitorId,
      sapId: this.sapId
    }

    this.getImportableExhibitor(getImportableExhibitorIn);

  }

  getExhibitorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getImportableExhibitor(getImportableExhibitorIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getImportableExhibitor(getImportableExhibitorIn)
      .subscribe((data: object) => {
        this.getImportableExhibitorOk(data);
      },
        error => {
          this.getImportableExhibitorError(error);
        });

  }

  getImportableExhibitorOk(data) {

    this.loader.count--;
    this.importData = data;

  }

  getImportableExhibitorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  ngOnInit() {

    this.domService.addClassToBody('bg-gray');
    this.exhibitorData['exhibitorId'] = this.exhibitorId;

    this.catalogueService.getDataProperties().subscribe(data => {
      this.catalogueProperties = data;
    });
    
    let getSocialNetworkIn = {
      event: this.eventName
    };
    
    let getPublishedProductsIn = {
      exhibitorId: this.exhibitorId 
    };
    
    let getCategoriesIn = {
      exhibitorId: this.exhibitorId 
    };
    
    let getProjectionIn = {
      exhibitorId: this.exhibitorId ,
      projection: 'detail'
    };
    
    
    let getImagesIn = {
      exhibitorId: this.exhibitorId 
    };

    let getFiraMapsIn = {
      id: this.exhibitorId ,
      event:  this.eventName
    };

    let getOdsActiveIn = {
      eventName:  this.eventName
    }
    let getExhibitorIn = {
      exhibitorId: this.exhibitorId
    }


    this.getProjection(getProjectionIn);

    this.getPublishedProducts(getPublishedProductsIn);
    this.getSocialNetwork(getSocialNetworkIn);
    this.getCategories(getCategoriesIn);
    this.getImages(getImagesIn);
    this.getFiraMaps(getFiraMapsIn);
    this.getOdsActive(getOdsActiveIn);
    this.getExhibitor(getExhibitorIn);



  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
